export const environment = {
  production: false,
  firebase: {
    apiKey: 'AIzaSyD82Zimb2Lr1RJvGu3GxoShQVAflcHwERY',
    authDomain: 'sza-preprod.firebaseapp.com',
    projectId: 'sza-preprod',
    storageBucket: 'sza-preprod.appspot.com',
    messagingSenderId: '359616739836',
    appId: '1:359616739836:web:a814a6773061cc55221a79',
    measurementId: 'G-24CME2SHXC',
  },
  TENANT_ID: 'qa-ln-home-stejc',
  API_URL: 'https://qa.api.lunanuevahome.com',
  BLOG_API_URL: 'https://lunanueva-blog-api-qa',
  BUCKET_URL: 'https://qa.stg.lunanuevahome.com/',
  GOOGLE_STORAGE_URL: 'https://storage.googleapis.com/qa.stg.lunanuevahome.com',
  SEIZA_URL: 'https://seiza-ti.cl',
  LN_PROPERTIES_URL: 'https://lunanuevapro.com',
  LN_PORTAL_URL: 'https://lunanuevaportal.com',
  LN_WHATSAPP_URL: 'https://wa.me/+50245085136',
  LN_INSTAGRAM_URL: 'https://www.instagram.com/lunanueva.pm/?igsh=eXJ2Yjc5MXdvZGs4',
  CLOUDFLARE_TURNSTILE_SCRIPT_URL: 'https://challenges.cloudflare.com/turnstile/v0/api.js',
  recaptcha: {
    publicKey: '0x4AAAAAABjfU_N8i6ghXtu9',
  },
  endpoints: {
    products: 'api/v1/products',
    productDetails: 'api/v1/sellers',
    searcher: 'api/v1/search',
    shoppingCart: 'api/v1/cart',
    orders: 'api/v1/orders',
    contact: 'api/v1/contact',
    contactOptions: 'api/v1/contact/options',
    sellers: 'api/v1/sellers',
    blog: {
      articles: 'api/v1/blog/articles',
    },
  },
  shareURL: {
    WHATSAPP: 'https://wa.me/?text=',
    FACEBOOK: 'https://www.facebook.com/sharer/sharer.php?u=',
    LINKEDIN: 'https://www.linkedin.com/sharing/share-offsite/?url=',
  },
  banners: {
    ABOUT_US: 'about-us-banner.jpg',
    CONTACT: 'contacto-banner.jpeg',
    PURCHASE_COMPLETION: 'ln_tejido.jpg',
    LOGO1: 'ln_logo1.jpg',
    LOGO2: 'ln_logo2.jpg',
    LOGO3: 'ln_logo3.jpg',
    SERVICES_DESIGN: 'services-design.png',
    SERVICES_DESIGN1: '1b.png',
    SERVICES_DESIGN2: '2b.png',
    SERVICES_DESIGN3: '3b.png',
    SERVICES_DESIGN4: '4b.png',
    SERVICES_DESIGN5: '5b.png',
    SERVICES_DESIGN6: '6b.png',
    SERVICES_DESIGN7: '7b.png',
    SERVICES_MANAGEMENT: 'services-management.png',
    BLOG: 'banner_blog.png',
  },
  braulioWidget: {
    scriptUrl: 'https://storage.googleapis.com/openagents-widget-mf/widget-umd/braulio.umd.js',
    agentUrl: 'https://luna-nueva.agent.openagents.io',
    clientData: {
      agentId: '69a05ea59316513da49867fa',
      channelId: '69ebf61dbbe875a4f2d5cc1a',
      tenantId: '69a059a7890a73bf1e4a4296',
    },
  },
};
